import regions from '@/assets/data/Regions.json'

export default ({ app }, inject) => {
  const utils = {
    formatProcedureName (procedure, collectivite) {
      if (procedure.name) {
        if (procedure.name_complement
          && !procedure.name.endsWith(procedure.name_complement) // do not display twice the name_complement when the name already includes it (old procedures)
        ) {
          return procedure.name + ' - ' + procedure.name_complement
        }
        return procedure.name
      }
      const isInter = procedure?.procedures_perimetres?.length > 1

      let collectivitePorteuse = collectivite

      if (
        isInter &&
        collectivite &&
        procedure.collectivite_porteuse_id !== collectivitePorteuse?.code
      ) {
        collectivitePorteuse = [
          ...collectivite.groupements,
          ...collectivite.membres
        ].find(e => e.code === procedure.collectivite_porteuse_id)
      }

      const parts = [
        procedure.type,
        procedure.numero,
        procedure.doc_type +
        (procedure.is_pluih && !procedure.doc_type.includes('H') ? 'H' : ''),
        collectivitePorteuse?.intitule ?? ''
      ].filter(Boolean)
      const name = parts.join(' ')

      if (procedure.name_complement) {
        return name + ' - ' + procedure.name_complement
      }

      return name
    },
    formatEventProfileToCreator (event) {
      if (event.profiles) {
        return this.formatProfileToCreator(event.profiles)
      } else if (event.from_sudocuh) {
        return { avatar: 'S', label: 'Sudocuh', color: '#3A3A3A', poste: 'Historique' }
      } else {
        return { avatar: 'D', label: 'Docurba', color: 'primary', poste: 'Système' }
      }
    },
    formatProfileToCreator (profile) {
      let creator = null
      if (profile.firstname && profile.lastname) {
        creator = { avatar: profile.firstname[0], label: `${profile.firstname} ${profile.lastname.toUpperCase()}`, poste: profile.poste, detailsPoste: profile.other_poste }
      } else if (profile.email) {
        creator = { avatar: profile?.email[0], label: `${profile.email}`, poste: profile?.poste, detailsPoste: profile?.other_poste }
      }
      creator.color = profile.side === 'etat' ? '#69DF97' : '#FA7659'
      creator.email = profile.email
      creator.side = profile.side
      creator.legacy_sudocu = profile.legacy_sudocu ?? false
      creator.id = profile.user_id
      creator.initiator = !!profile.initiator
      creator.profile = profile
      creator.region = profile.region
      return creator
    },
    // ⚠️ Les clefs sont a minima aussi utilisées pour Pipedrive et Brevo
    POSTES_ETAT: {
      ddt: 'DDT(M)/DEAL',
      dreal: 'DREAL'
    },
    ROLES_ETAT: {
      chef_unite: 'Chef·fe d\'unité/de bureau/de service et adjoint·e',
      redacteur_pac: 'Rédacteur·ice de PAC',
      suivi_procedures: 'Chargé·e de l\'accompagnement des collectivités',
      referent_sudocuh: 'Référent·e Sudocuh'
    },
    POSTES_COLLECTIVITE: {
      be: 'Bureau d\'études',
      elu: 'Collectivité, Élu·e',
      employe_mairie: 'Collectivité, Technicien·ne ou employé·e',
      agence_urba: 'Agence d\'urbanisme',
      autre: 'Autre'
    },
    POSTES_PPA: {
      region: 'Région'
    },
    formatPostesAndSide (profile) {
      let postes = []

      const POSTES = { ...this.POSTES_ETAT, ...this.POSTES_COLLECTIVITE, ...this.POSTES_PPA }
      if (profile.poste === 'region') {
        const region = regions.find(r => r.code.padStart(2, '0') === profile.region)
        postes.push(`${POSTES[profile.poste]} ${region.name}`)
      } else if (profile.poste !== 'autre') {
        postes.push(POSTES[profile.poste])
      }

      for (const poste of profile.detailsPoste ?? []) {
        postes.push(this.ROLES_ETAT[poste] ?? poste)
      }
      postes = postes.join(', ')
      if (profile.side === 'ppa') {
        postes = `${postes} (PPA)`
      }

      return postes
    },
    updateRouteQueryParam (key, newValue) {
      app.router.replace({
        ...app.router.currentRoute,
        query: {
          ...app.router.currentRoute.query,
          [key]: newValue
        }
      })
    },
    hasSameArrayItems (a, b) {
      return a.length === b.length &&
        a.every(item => b.includes(item))
    },
    getRouteQueryArray (routeValue, defaultValue) {
      if (!routeValue) {
        return defaultValue
      }

      const value = routeValue.split(',')

      return value.length === 0 || this.hasSameArrayItems(value, defaultValue)
        ? defaultValue
        : value
    },
    updateRouteQueryArray (key, newValue, defaultValue) {
      this.updateRouteQueryParam(
        key,
        !newValue || newValue.length === 0 || this.hasSameArrayItems(newValue, defaultValue)
          ? undefined
          : newValue.join(',')
      )
    }
  }
  inject('utils', utils)
}

export function displayDate (value) {
  return value
    ? value.split('T')[0].split('-').reverse().join('/')
    : ''
}

export function getSortableText (value) {
  return value.toLowerCase().normalize('NFKD').replace(/[^a-z0-9]/g, '')
}

export function getUniquePropValues (arr, propOrGetter) {
  const getValue = typeof propOrGetter === 'string' ? item => item[propOrGetter] : propOrGetter
  const values = []
  const existingValues = {}

  arr.forEach((item) => {
    const value = getValue(item)

    if (!value || existingValues[value]) {
      return
    }

    existingValues[value] = true
    values.push(value)
  })

  return values
}

export function keyBy (values, propOrGetter) {
  const getKey = typeof propOrGetter === 'string' ? item => item[propOrGetter] : propOrGetter
  const valuesByKey = {}

  values.forEach((value) => {
    const key = getKey(value)

    if (!key) {
      return
    }

    valuesByKey[key] = value
  })

  return valuesByKey
}
